<template>
  <div class="hangjiaBox" v-if="expertAuthor.authorId">
    <div class="flex">
      <strong><a :href="expertAuthor.authorUrl" target="_blank" @click="countAd(4232)"><em>{{expertAuthor.authorName}}</em>-太平洋号作者</a></strong>
      <a class="cj" href="https://www.pcauto.com.cn/hj/join/" target="_blank">申请加入创作</a>
    </div>
    <div class="hangjiaCon">
      <div class="hangjiaInfo">
        <a class="hangjiaLogo" :href="expertAuthor.authorUrl" target="_blank" @click="countAd(4233)"><img :src="expertAuthor.faceImg" width="64" height="64"/></a>
        <p>
          <span>太平洋号：<a :href="expertAuthor.authorUrl" target="_blank" @click="countAd(4234)">{{expertAuthor.authorName}}</a></span>
        </p>
        <p>
          <span>文章数：<a :href="expertAuthor.authorUrl" target="_blank" @click="countAd(4235)">{{expertAuthor.totalArticleNum}}</a></span>
          <span>人气值：<i>{{expertAuthor.popularity}}</i></span>
        </p>
      </div>

      <div class="hangjiaTxt">
        <div class="tit">最新文章：</div>
        <ul class="cxltUl hangjiaUl" v-if="expertAuthor.articleList && expertAuthor.articleList.length > 0">
          <li v-for="(article,index) in expertAuthor.articleList" :key="index"><a :href="article.articleUrl" target="_blank" @click="countAd(4236)">{{article.articleTitle}}</a></li>
        </ul>
        <p v-else class="nothing">这位太平洋有点懒,什么也没写~</p>
      </div>
      <a class="more" :href="expertAuthor.authorUrl" target="_blank" @click="countAd(4237)">查看更多文章&gt;&gt;</a>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Author',
    props: {
        expertAuthor: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        // titleBp() { //模块标题埋点
        //     if(this.$global.tab.title === 'auto_index') { //综合页title
        //         this.countAd(4232)
        //     }else { // 太平洋号页面title
        //         this.countAd(4232)
        //     }
        // },

    },
    computed: {
        // pvCount() {
        //     return  this.$utils.countFormatter(this.expertAuthor.totalPv,2)
        // }
    },
};
</script>

<style lang="scss" scoped>
.hangjiaBox {
    padding-bottom: 10px;
    .flex{
      display: flex;
      align-items: center;
      justify-content: space-between;
      .cj{
        font-size: 14px;
      }
    }
    strong {
        font-weight: normal;
        font-size: 16px;
        line-height: 32px; 
        a {
            text-decoration: underline;
            color: #225599;  
            em {
                color: #c00;
                text-decoration: underline;
                font-style: normal;                
            }          
        }       
    }
    .hangjiaCon {
        border: 1px solid #f0f0f0;
        .hangjiaInfo {
            font-size: 16px;
            line-height: 30px;
            padding: 20px 10px;
            .hangjiaLogo {
                position: absolute;
                margin-top: -2px;
                img {
                    border: 0;
                    vertical-align: middle;                     
                }
            }   
            p {
                padding-left: 75px;
                color: #777;    
                span {
                        margin-right: 33px;
                        a {
                            color: #000000;
                        }  
                        i {
                            color: #333;
                            font-style: normal;
                        }
                }            
            }         
        }   
        .hangjiaUl {
            margin-top: 10px;
            li {
                line-height: 30px;
                height: 30px;
                overflow: hidden;
                font-size: 14px;
                background-position: 0 center;
                line-height: 22px;
                background: url(//www1.pcauto.com.cn/2014/kuaisou/images/cxltil.png) 0 10px no-repeat;
                padding-left: 10px;
                clear: both;
                overflow: hidden;
                a {
                    color: #225599;
                }
            }
        }    
        .hangjiaTxt {
            padding: 12px 10px 10px;
            .tit {
                font-size: 14px;
                color: #777;
            }
            .nothing {
                line-height: 20px;
                color: #333333;
            }
        }         
    }
    .more {
        display: block;
        width: 620px;
        margin: 0 -1px -1px;
        height: 32px;
        line-height: 32px;
        color: #888;
        background: #f5f6f8;  
        text-align: center;      
    }
}
</style>
